import { render } from "./UnidadmedidaList.vue?vue&type=template&id=0979c448&scoped=true"
import script from "./UnidadmedidaList.vue?vue&type=script&lang=js"
export * from "./UnidadmedidaList.vue?vue&type=script&lang=js"

import "./UnidadmedidaList.vue?vue&type=style&index=0&id=0979c448&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0979c448"]])

export default __exports__